module.exports = __webpack_public_path__ + "static/smartway-logo-51ee245092b5b2bab1ae21c9fb4f5166.svg";